import Store from 'components/store';
import React from 'react';

export default function Setting() {
  return <Store />;
}
